import { Container } from "react-bootstrap";

function DreiDDruck() {
  return (
    <Container style={{ padding: "1.5rem" }}>
      <h1>3D-Druck</h1>
      <br />

      <p>
        Ergänzend zu CAD-Schulungen biete ich Einführungstrainings im Bereich
        3D-Druck an.
      </p>

      <p>
        Die Schulungen vermitteln sowohl die theoretischen Grundlagen als auch
        praxisnahe Aspekte – von der druckgerechten Konstruktion über geeignete
        Modellierungsstrategien bis hin zur Auswahl passender Druckverfahren.
      </p>

      <p>
        Durch eigene Erfahrung mit FDM- und Resin-Druckern können Inhalte
        anschaulich und anhand realer Anwendungsbeispiele vermittelt werden.
      </p>

      <div className="spacer"></div>
    </Container>
  );
}

export default DreiDDruck;
